import React, {useEffect, useState, useRef, useCallback} from 'react';
import Content from '../layout/content/Content';
import {
  getTemporalesMro,
  updateTemporalesMro,
  insertTemporalesMro,
  deleteTemporalesMro,
  getHistoryTemporal,
} from './temporales';
import Aviso from '../plasticos/components/Aviso';
import Swal from 'sweetalert2';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tooltip,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';

import {
  Block,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
} from '../components/Component';
import Head from '../layout/head/Head';
import MroDocuments from './components/MroDocuments';
import MroDocumentsList from './components/MroDocumentsList';
import TemporalesExcelUpload from './components/TemporalesExcelUpload';
import TemporalesMroAvisos from './components/TemporalesMroAvisos';

const TemporalesMro = () => {
  const [avisos, setAvisos] = useState([]);
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyTooltipOpenId, setHistoryTooltipOpenId] =
    useState(null);
  const [historyLoadingId, setHistoryLoadingId] = useState(null);
  const [isLoadingTable, setIsLoadingTable] = useState(true);
  const [deleteLoadingId, setDeleteLoadingId] = useState(null);
  const [documentsModalOpen, setDocumentsModalOpen] = useState(false);
  const [selectedPoNumber, setSelectedPoNumber] = useState(null);
  const [selectedTemporalId, setSelectedTemporalId] = useState(null);
  const [docActiveTab, setDocActiveTab] = useState('Sin Asignar');
  const [docCounts, setDocCounts] = useState({ total: 0, importCount: 0, exportCount: 0, unassignedCount: 0 });
  const [docRefreshTrigger, setDocRefreshTrigger] = useState(0);

  const handleDocCountsChange = useCallback((counts) => {
    setDocCounts(prev => {
      if (
        prev.total === counts.total &&
        prev.importCount === counts.importCount &&
        prev.exportCount === counts.exportCount &&
        prev.unassignedCount === counts.unassignedCount
      ) {
        return prev;
      }
      return counts;
    });

    setDocActiveTab(prevTab => {
      // Si estamos en Sin Asignar pero no hay archivos sin asignar, cambiar a Import
      if (prevTab === 'Sin Asignar' && counts.unassignedCount === 0) {
        return 'Import';
      }
      return prevTab;
    });
  }, []);
  const [excelUploadModalOpen, setExcelUploadModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [emailConfigModalOpen, setEmailConfigModalOpen] = useState(false);
  const [originalRow, setOriginalRow] = useState(null); // Para comparar cambios
  const [hasChanges, setHasChanges] = useState(false); // Indica si hay cambios
  const [modalActiveTab, setModalActiveTab] = useState('basico');
  const [envaseSubTab, setEnvaseSubTab] = useState('fechas_env');
  const MODAL_TABS_BASE = ['basico', 'material', 'financiero', 'fechas', 'prorrogas', 'customs', 'estado'];
  const MODAL_TABS_ENVASE = ['envases'];
  const MODAL_TABS = editRow?.es_envase
    ? [...MODAL_TABS_BASE, ...MODAL_TABS_ENVASE]
    : MODAL_TABS_BASE;
  // Flat navigation steps – expands envases tab into its 2 sub-tabs
  const NAV_STEPS = editRow?.es_envase
    ? ['basico', 'material', 'financiero', 'fechas', 'prorrogas', 'customs', 'estado', 'env_fechas']
    : ['basico', 'material', 'financiero', 'fechas', 'prorrogas', 'customs', 'estado'];
  const currentNavStep = modalActiveTab === 'envases' ? 'env_fechas' : modalActiveTab;
  const currentNavIdx = NAV_STEPS.indexOf(currentNavStep);
  const navigateToStep = (step) => {
    if (step === 'env_fechas') { setModalActiveTab('envases'); setEnvaseSubTab('fechas_env'); }
    else { setModalActiveTab(step); }
  };
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Search state
  const [searchTerm, setSearchTerm] = useState('');
  const searchInputRef = useRef(null);
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('user', user);
  // Función para refrescar datos después de subir archivo
  const refreshData = async () => {
    try {
      const updatedData = await getTemporalesMro();
      setData(updatedData);
    } catch (error) {
      console.error('Error refreshing data:', error);
      mostrarAviso('Error al actualizar datos', false, false);
    }
  };

  // Search and filtering logic
  const getFilteredData = () => {
    if (!searchTerm.trim()) {
      return data;
    }
    
    return data.filter((row) => {
      const searchString = searchTerm.toLowerCase().trim();
      
      // Search in all visible columns
      const searchableFields = [
        row.po_number?.toString(),
        row.responsible?.toString(),
        row.vendor?.toString(),
        row.mercaderia_descripcion?.toString(),
        row.destination?.toString(),
        row.serial?.toString(),
        row.origen_mercaderia?.toString(),
        row.marca_modelo?.toString(),
        row.ET?.toString(),
        row.IC?.toString(),
        row.status?.toString(),
        row.comentario?.toString(),
        // Include formatted dates
        row.due_date ? new Date(row.due_date).toLocaleDateString('es-AR') : '',
        row.aprobation_date ? new Date(row.aprobation_date).toLocaleDateString('es-AR') : '',
        row.fecha_embarque ? new Date(row.fecha_embarque).toLocaleDateString('es-AR') : '',
        row.fecha_vencimiento_temporal ? new Date(row.fecha_vencimiento_temporal).toLocaleDateString('es-AR') : '',
        row.fecha_retorno ? new Date(row.fecha_retorno).toLocaleDateString('es-AR') : '',
        // Include numeric fields
        row.peso_bruto?.toString(),
        row.peso_neto?.toString(),
        row.valor_declarar?.toString(),
        row.valor_reparacion?.toString(),
        row.sicnea_days?.toString()
      ];
      
      return searchableFields.some(field => 
        field && field.toLowerCase().includes(searchString)
      );
    });
  };

  // Pagination logic with filtered data
  const filteredData = getFilteredData();
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page
  };

  const getPaginationButtons = () => {
    const buttons = [];
    const maxVisibleButtons = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisibleButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
    
    if (endPage - startPage + 1 < maxVisibleButtons) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(i);
    }
    return buttons;
  };

  // Search handler
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  // Clear search
  const clearSearch = () => {
    setSearchTerm('');
    setCurrentPage(1);
  };

  // Reset page when data changes
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [data, currentPage, totalPages]);

  // Mostrar avisos
  const mostrarAviso = (titulo, estado, paraDetail) => {
    const nuevoAviso = { id: Date.now() + Math.random(), titulo, estado, paraDetail };
    setAvisos((prev) => [...prev, nuevoAviso]);
  };

  // Eliminar avisos después de 3 segundos
  useEffect(() => {
    if (avisos.length > 0) {
      const timeout = setTimeout(() => {
        setAvisos(avisos.slice(1));
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [avisos]);

  // Obtener datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getTemporalesMro();
        setData(result);
      } catch (error) {
        console.error('Error fetching temporalesMro data:', error);
        mostrarAviso('Error fetching data', false, false);
      } finally {
        setIsLoadingTable(false);
      }
    };
    fetchData();
  }, []);

  // Keyboard shortcuts for search
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Clear search with Escape key
      if (event.key === 'Escape' && searchTerm) {
        clearSearch();
      }
      
      // Focus search input with Ctrl+F
      if (event.ctrlKey && event.key === 'f') {
        event.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [searchTerm]);

  // Abrir modal para agregar nueva fila
  const handleAddRow = () => {
    setEditRow({
      po_number: '',
      responsible: '',
      vendor: '',
      mercaderia_descripcion: '',
      destination: '',
      peso_bruto: '',
      peso_neto: '',
      medidas_embalaje: '',
      serial: '',
      origen_mercaderia: '',
      marca_modelo: '',
      valor_declarar: '',
      valor_reparacion: '',
      fecha_presentacion_expediente: '',
      aprobation_date: '',
      sicnea_days: '',
      fecha_embarque: '',
      fecha_vencimiento_temporal: '',
      fecha_presentacion_prorroga: '',
      fecha_aprobacion_prorroga: '',
      dias_habilitados_prorroga: '',
      due_date: '',
      fecha_retorno: '',
      status: 'Activo',
      ET: '',
      IC: '',
      po_servicio: '',
      custom_declaration: '',
      channel: '',
      local_delivery_note: '',
      custom_doc_date: '',
      release_date: '',
      delivery_date: '',
      comentario: '',
      documents: 0,
      es_envase: 0,
      despacho_envase: '',
      fecha_presentacion_expediente_envase: '',
      fecha_aprobacion_expediente_envase: '',
      dias_habilitados_sicnea_envase: '',
      fecha_embarque_envase: '',
      fecha_vencimiento_temporal_envase: '',
      fecha_vencimiento_envase: '',
    });
    setOriginalRow(null); // No hay original en modo nuevo
    setIsNew(true);
    setHasChanges(true); // En modo nuevo, siempre hay "cambios"
    setModalActiveTab('basico');
    setEnvaseSubTab('fechas_env');
    setModalOpen(true);
  };

  // Guardar cambios (insertar o actualizar)
  const handleSave = async (row, index) => {
    try {
      // Helper function para formatear fechas
      const formatDateForDB = (dateValue) => {
        if (!dateValue) return null;
        if (dateValue === '' || dateValue === 'null') return null;
        try {
          const date = new Date(dateValue);
          if (isNaN(date.getTime())) return null;
          return date.toISOString().split('T')[0];
        } catch {
          return null;
        }
      };

      const formattedRow = {
        ...row,
        // Formatear TODAS las fechas
        fecha_presentacion_expediente: formatDateForDB(row.fecha_presentacion_expediente),
        aprobation_date: formatDateForDB(row.aprobation_date),
        fecha_embarque: formatDateForDB(row.fecha_embarque),
        fecha_vencimiento_temporal: formatDateForDB(row.fecha_vencimiento_temporal),
        fecha_presentacion_prorroga: formatDateForDB(row.fecha_presentacion_prorroga),
        fecha_aprobacion_prorroga: formatDateForDB(row.fecha_aprobacion_prorroga),
        due_date: formatDateForDB(row.due_date),
        fecha_retorno: formatDateForDB(row.fecha_retorno),
        // Formatear fechas de Customs
        custom_doc_date: formatDateForDB(row.custom_doc_date),
        release_date: formatDateForDB(row.release_date),
        delivery_date: formatDateForDB(row.delivery_date),
        // Formatear fechas de Carga envasada
        fecha_presentacion_expediente_envase: formatDateForDB(row.fecha_presentacion_expediente_envase),
        fecha_aprobacion_expediente_envase: formatDateForDB(row.fecha_aprobacion_expediente_envase),
        fecha_embarque_envase: formatDateForDB(row.fecha_embarque_envase),
        fecha_vencimiento_temporal_envase: formatDateForDB(row.fecha_vencimiento_temporal_envase),
        fecha_vencimiento_envase: formatDateForDB(row.fecha_vencimiento_envase),
      };

      let result;
      if (row.id) {
        result = await updateTemporalesMro(formattedRow, user);
      } else {
        result = await insertTemporalesMro(formattedRow, user);
      }
      if (result) {
        mostrarAviso('Fila guardada correctamente', true, false);
      } else {
        mostrarAviso('Error al guardar fila', false, false);
      }
      const updatedData = await getTemporalesMro();
      setData(updatedData);
      setEditRow(null);
      setIsNew(false);
    } catch (error) {
      console.error('Error saving row:', error);
      mostrarAviso('Error al guardar fila', false, false);
    }
  };

  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: '¡No podrás revertir esto!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar!',
    });
    if (result.isConfirmed) {
      setDeleteLoadingId(row.id || row.po_number || row);
      try {
        await deleteTemporalesMro(row.id, user, row);
        mostrarAviso('Fila eliminada correctamente', true, false);
        const updatedData = await getTemporalesMro();
        setData(updatedData);
      } catch (error) {
        console.error('Error deleting row:', error);
        mostrarAviso('Error al eliminar fila', false, false);
      } finally {
        setDeleteLoadingId(null);
      }
    }
  };

  // Manejar el historial de cambios
  const handleHistory = async (row) => {
    setHistoryLoadingId(row.id || row.po_number || row);
    try {
      const history = await getHistoryTemporal(row);
      if (Array.isArray(history) && history.length > 0) {
        // Ordenar por fecha y hora ascendente
        const sorted = [...history].sort((a, b) => {
          const dateA = new Date(`${a.fecha}T${a.hora}`);
          const dateB = new Date(`${b.fecha}T${b.hora}`);
          return dateB - dateA;
        });
        setHistoryData(sorted);
        setHistoryModalOpen(true);
      } else {
        mostrarAviso(
          'No hay cambios históricos para este documento',
          false,
          false
        );
      }
    } catch (error) {
      console.error('Error fetching history:', error);
      mostrarAviso('Error al obtener historial', false, false);
    } finally {
      setHistoryLoadingId(null);
    }
  };

  // Abrir modal para editar
  const handleEdit = (row, index) => {
    // Hacer copia profunda
    const originalCopy = JSON.parse(JSON.stringify({...row, index}));
    const rowCopy = JSON.parse(JSON.stringify({...row, index}));
    
    setOriginalRow(originalCopy);
    setEditRow(rowCopy);
    setIsNew(false);
    setHasChanges(false);
    setModalActiveTab('basico');
    setEnvaseSubTab('fechas_env');
    setModalOpen(true);
  };

  // Detectar cambios comparando editRow con originalRow
  const detectChanges = (updatedRow) => {
    if (isNew) {
      setHasChanges(true);
      return;
    }
    
    if (!originalRow) {
      setHasChanges(false);
      return;
    }
    
    // Comparar simple: si algo cambió, hay cambios
    const hasChanged = JSON.stringify(updatedRow) !== JSON.stringify(originalRow);
    setHasChanges(hasChanged);
  };

  // Manejar cambios en el modal
  const handleModalChange = (e, field) => {
    const {value} = e.target;
    const updatedRow = {...editRow, [field]: value};
    setEditRow(updatedRow);
    detectChanges(updatedRow);
  };

  // Guardar cambios desde el modal
  const handleModalSave = async () => {
    setIsSaving(true);
    try {
      if (isNew) {
        await handleSave(editRow, 'new');
      } else {
        await handleSave(editRow, editRow.index);
      }
      setModalOpen(false);
      setEditRow(null);
      setOriginalRow(null);
      setIsNew(false);
      setHasChanges(false);
    } catch (error) {
      console.error('Error saving data:', error);
    } finally {
      setIsSaving(false);
    }
  };

  // Manejar cambios en los campos de la tabla
  const handleChange = (e, index, field) => {
    const {value} = e.target;
    if (index === 'new') {
      setEditRow((prev) => ({...prev, [field]: value}));
    } else {
      setData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = {...updatedData[index], [field]: value};
        return updatedData;
      });
    }
  };

  // Función para formatear fechas en dd/mm/yyyy
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date)) return '';
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatNumber = (num) =>
    num != null
      ? Number(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : '';

  const cellStyle = {
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: '8px',
    border: '1px solid #ddd',
  };

  const inputStyle = {
    textAlign: 'center',
    height: '35px',
    fontSize: '14px',
    padding: '5px',
    width: '100%',
    boxSizing: 'border-box',
  };

  return (
    <React.Fragment>
      <Head title="Temporales MRO" />
      <Content>
        {avisos.map((aviso) => (
          <Aviso
            key={aviso.id}
            titulo={aviso.titulo}
            estado={aviso.estado}
            paraDetail={aviso.paraDetail}
          />
        ))}
        <Block className="p-1">
          <BlockHead>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <BlockTitle className="text-ssbnaranja" tag="h5">
                Temporales MRO
              </BlockTitle>
              <Button
                color="light"
                style={{
                  backgroundColor: '#7c3aed',
                  borderColor: '#7c3aed',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 16px',
                  fontWeight: '500',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#6d28d9';
                  e.currentTarget.style.borderColor = '#6d28d9';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#7c3aed';
                  e.currentTarget.style.borderColor = '#7c3aed';
                }}
                onClick={() => 
                  setEmailConfigModalOpen(true)
                }
              >
                <Icon name="bell" />
                Aviso Mails
              </Button>
            </div>
          </BlockHead>
          
          {/* Search Input */}
          <div style={{
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            flexWrap: 'wrap'
          }}>
            <div style={{display: 'flex', alignItems: 'center', gap: '10px', flex: '1', minWidth: '300px'}}>
              <Icon name="search" style={{color: '#6c757d'}} />
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Buscar en todos los campos (PO, responsable, vendor, estado, fechas, etc.)"
                value={searchTerm}
                onChange={handleSearchChange}
                style={{
                  flex: '1',
                  padding: '10px 15px',
                  border: '2px solid #e9ecef',
                  borderRadius: '25px',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  minWidth: '250px'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#007bff';
                  e.target.style.boxShadow = '0 0 0 0.2rem rgba(0,123,255,.25)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
              {searchTerm && (
                <Button
                  color="light"
                  size="sm"
                  onClick={clearSearch}
                  style={{
                    borderRadius: '50%',
                    width: '35px',
                    height: '35px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #dee2e6'
                  }}
                  title="Limpiar búsqueda"
                >
                  <Icon name="cross" style={{fontSize: '12px'}} />
                </Button>
              )}
            </div>
            
            {searchTerm && (
              <div style={{
                fontSize: '14px',
                color: '#6c757d',
                fontStyle: 'italic'
              }}>
                {filteredData.length} resultado{filteredData.length !== 1 ? 's' : ''} de {data.length} total{data.length !== 1 ? 'es' : ''}
              </div>
            )}
            
            {/* Keyboard shortcuts hint */}
            {/*<div style={{
              fontSize: '12px',
              color: '#6c757d',
              fontStyle: 'italic'
            }}>
              💡 Tip: Presiona <kbd style={{
                background: '#f1f3f4',
                border: '1px solid #dadce0',
                borderRadius: '3px',
                padding: '1px 4px',
                fontSize: '11px'
              }}>Ctrl+F</kbd> para buscar, <kbd style={{
                background: '#f1f3f4',
                border: '1px solid #dadce0',
                borderRadius: '3px',
                padding: '1px 4px',
                fontSize: '11px'
              }}>Escape</kbd> para limpiar
            </div>*/}
          </div>
          
          {isLoadingTable ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 200,
              }}
            >
              <span 
                className="spinner-border"
                role="status"
                aria-hidden="true"
                style={{width: 50, height: 50}}
              ></span>
            </div>
          ) : filteredData.length === 0 && searchTerm ? (
            // No search results found
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 200,
              padding: '40px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '1px solid #e9ecef'
            }}>
              <Icon name="search" style={{fontSize: '48px', color: '#6c757d', marginBottom: '16px'}} />
              <h5 style={{color: '#6c757d', marginBottom: '8px'}}>No se encontraron resultados</h5>
              <p style={{color: '#6c757d', textAlign: 'center', marginBottom: '16px'}}>
                No hay registros que coincidan con "<strong>{searchTerm}</strong>"
              </p>
              <Button color="outline-primary" size="sm" onClick={clearSearch}>
                <Icon name="cross" style={{marginRight: '5px'}} />
                Limpiar búsqueda
              </Button>
            </div>
          ) : filteredData.length === 0 ? (
            // No data at all
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 200,
              padding: '40px'
            }}>
              <Icon name="inbox" style={{fontSize: '48px', color: '#6c757d', marginBottom: '16px'}} />
              <h5 style={{color: '#6c757d'}}>No hay datos disponibles</h5>
              <p style={{color: '#6c757d'}}>Agregue el primer registro para comenzar</p>
            </div>
          ) : (
            <table
              className="table"
              style={{width: '100%', borderCollapse: 'collapse'}}
            >
              <thead>
                <tr>
                  {[
                    'N° de PO',
                    'Fecha de vencimiento',
                    'Fecha de aprobación expediente',
                    'ET',
                    'IC',
                    /*'Destino',
                    'Serial',
                    'Responsable/Usuario del material',
                    'Días habilitados por SICNEA',*/
                    'Estado',
                    'Documents',
                    'Acciones',
                  ].map((header, index) => (
                    <th
                      key={index}
                      style={{
                        padding: '8px',
                        backgroundColor: '#f5f5f5',
                        textAlign: 'center',
                        border: '1px solid #ddd',
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentItems.map((row, index) => (
                  <tr key={row.id || index}>
                    <td style={cellStyle}>{row.po_number}</td>
                    <td style={cellStyle}>
                      {(formatDate(row.due_date) || formatDate(row.fecha_vencimiento_temporal)) || '-'}
                    </td>
                    <td style={cellStyle}>
                      {formatDate(row.aprobation_date) || '-'}
                    </td>
                    {/*<td style={cellStyle}>{row.destination}</td>
                    <td style={cellStyle}>{row.serial}</td>
                    <td style={cellStyle}>{row.responsible}</td>
                    <td style={cellStyle}>{row.sicnea_days}</td>*/}
                    <td style={cellStyle}>{row.ET || '-'}</td>
                    <td style={cellStyle}>{row.IC || '-'}</td>
                    <td style={cellStyle}>
                      <span
                        style={{
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          color: 'white',
                          backgroundColor:
                            row.status === 'Activo'
                              ? '#28a745'
                              : row.status === 'Pronto a vencer'
                              ? '#ffc107'
                              : row.status === 'Vencido'
                              ? '#dc3545'
                              : '#6c757d',
                        }}
                      >
                        {row.status}
                      </span>
                    </td>
                    <td style={cellStyle}>
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => {
                          setSelectedPoNumber(row.po_number);
                          setSelectedTemporalId(row.id);
                          setDocCounts({ total: 0, importCount: 0, exportCount: 0, unassignedCount: 0 });
                          setDocActiveTab('Sin Asignar');
                          setDocumentsModalOpen(true);
                        }}
                      >
                        <Icon name="file-docs" />
                      </Button>
                    </td>
                    <td
                      style={{
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        border: '1px solid #ddd',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '5px',
                          marginLeft: '10px',
                        }}
                      >
                        <Button
                          color="info"
                          onClick={() => handleEdit(row, index)}
                        >
                          <Icon name="edit" />
                        </Button>
                        <Button
                          color="danger"
                          onClick={() => handleDelete(row)}
                        >
                          {deleteLoadingId ===
                          (row.id || row.po_number || row) ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <Icon name="trash" />
                          )}
                        </Button>
                        <Button
                          color="warning"
                          id={`history-btn-${row.id || index}`}
                          onClick={() => handleHistory(row)}
                          onMouseEnter={() =>
                            setHistoryTooltipOpenId(row.id || index)
                          }
                          onMouseLeave={() =>
                            setHistoryTooltipOpenId(null)
                          }
                          disabled={
                            historyLoadingId ===
                            (row.id || row.po_number || row)
                          }
                        >
                          {historyLoadingId ===
                          (row.id || row.po_number || row) ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <Icon name="clock" />
                          )}
                        </Button>
                        <Tooltip
                          placement="left"
                          isOpen={
                            historyTooltipOpenId === (row.id || index)
                          }
                          target={`history-btn-${row.id || index}`}
                          toggle={() =>
                            setHistoryTooltipOpenId(
                              historyTooltipOpenId ===
                                (row.id || index)
                                ? null
                                : row.id || index
                            )
                          }
                          delay={{show: 150, hide: 150}}
                        >
                          Cambios históricos de la Temporal.
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          
          {/* Pagination Controls */}
          {!isLoadingTable && data.length > 0 && (
            <div style={{
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              margin: '20px 0',
              flexWrap: 'wrap',
              gap: '10px'
            }}>
              {/* Items per page selector */}
              <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                <span>Mostrar:</span>
                <select 
                  value={itemsPerPage} 
                  onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                  style={{
                    padding: '5px 10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px'
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span>registros por página</span>
              </div>

              {/* Pagination info */}
              <div style={{fontSize: '14px', color: '#666'}}>
                Mostrando {indexOfFirstItem + 1} a {Math.min(indexOfLastItem, filteredData.length)} de {filteredData.length} registros
                {searchTerm && ` (filtrados de ${data.length} totales)`}
              </div>

              {/* Pagination buttons */}
              <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => goToPage(1)}
                  disabled={currentPage === 1}
                >
                  ««
                </Button>
                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ‹
                </Button>
                
                {getPaginationButtons().map(pageNumber => (
                  <Button
                    key={pageNumber}
                    color={currentPage === pageNumber ? "primary" : "outline-primary"}
                    size="sm"
                    onClick={() => goToPage(pageNumber)}
                    style={{minWidth: '35px'}}
                  >
                    {pageNumber}
                  </Button>
                ))}
                
                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  ›
                </Button>
                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => goToPage(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  »»
                </Button>
              </div>
            </div>
          )}
          
          {isLoadingTable ? (
            <></>
          ) : (
            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
              <Button color="primary" onClick={handleAddRow}>
                <Icon name="plus" /> Agregar Temporal
              </Button>
              <Button color="success" onClick={() => setExcelUploadModalOpen(true)}>
                <Icon name="upload" /> Cargar desde Excel
              </Button>
            </div>
          )}
        </Block>
        {/* Modal para agregar o editar fila */}
        <Modal
          isOpen={modalOpen}
          toggle={() => {
            setModalOpen(!modalOpen);
            setIsNew(false);
            setHasChanges(false);
            setOriginalRow(null);
          }}
          style={{maxWidth: '1300px', width: '95vw'}}
        >
          <ModalHeader
            toggle={() => {
              setModalOpen(!modalOpen);
              setIsNew(false);
              setHasChanges(false);
              setOriginalRow(null);
            }}
          >
            {isNew ? 'Agregar Temporal' : 'Editar Temporal'}
          </ModalHeader>
          <ModalBody style={{padding: '0'}}>
            {editRow && (
              <>
                {/* Tab navigation */}
                <Nav tabs style={{padding: '0 16px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6', flexWrap: 'nowrap', overflowX: 'auto', marginBottom: '0'}}>
                  {[
                    {id: 'basico', label: 'Básico'},
                    {id: 'material', label: 'Material'},
                    {id: 'financiero', label: 'Financiero'},
                    {id: 'fechas', label: 'Fechas'},
                    {id: 'prorrogas', label: 'Prórrogas'},
                    {id: 'customs', label: 'Customs'},
                    {id: 'estado', label: 'Estado'},
                  ].map(tab => (
                    <NavItem key={tab.id}>
                      <NavLink
                        className={modalActiveTab === tab.id ? 'active' : ''}
                        onClick={() => setModalActiveTab(tab.id)}
                        style={{
                          cursor: 'pointer',
                          padding: '10px 14px',
                          fontSize: '13px',
                          fontWeight: modalActiveTab === tab.id ? '600' : '400',
                          color: modalActiveTab === tab.id ? '#007bff' : '#6c757d',
                          borderBottom: modalActiveTab === tab.id ? '2px solid #007bff' : '2px solid transparent',
                          backgroundColor: 'transparent',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {tab.label}
                      </NavLink>
                    </NavItem>
                  ))}
                  {/* Tab "Envases" – el checkbox ES el tab */}
                  <NavItem>
                    <NavLink
                      className={modalActiveTab === 'envases' ? 'active' : ''}
                      onClick={() => {
                        if (!editRow?.es_envase) {
                          handleModalChange({target: {value: 1}}, 'es_envase');
                        }
                        setModalActiveTab('envases');
                      }}
                      style={{
                        cursor: 'pointer',
                        padding: '10px 14px',
                        fontSize: '13px',
                        fontWeight: modalActiveTab === 'envases' ? '600' : '400',
                        color: modalActiveTab === 'envases' ? '#007bff' : '#6c757d',
                        borderBottom: modalActiveTab === 'envases' ? '2px solid #007bff' : '2px solid transparent',
                        backgroundColor: 'transparent',
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={!!editRow?.es_envase}
                        onChange={(e) => {
                          e.stopPropagation();
                          const checked = e.target.checked;
                          handleModalChange({target: {value: checked ? 1 : 0}}, 'es_envase');
                          if (checked) {
                            setModalActiveTab('envases');
                          } else if (modalActiveTab === 'envases') {
                            setModalActiveTab('estado');
                          }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        style={{cursor: 'pointer', width: '14px', height: '14px'}}
                      />
                      <span style={{marginBottom: 0}}>Envases</span>
                    </NavLink>
                  </NavItem>
                </Nav>

                {/* Tab content */}
                <TabContent activeTab={modalActiveTab} style={{padding: '0 20px 20px 20px'}}>

                  {/* ── Tab: Básico ── */}
                  <TabPane tabId="basico">
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                      <div>
                        <label>N° de PO / Centro de Costos</label>
                        <input
                          value={editRow.po_number || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'po_number')}
                        />
                      </div>
                      <div>
                        <label>Responsable/Usuario del material</label>
                        <input
                          value={editRow.responsible || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'responsible')}
                        />
                      </div>
                      <div>
                        <label>Vendor</label>
                        <input
                          value={editRow.vendor || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'vendor')}
                        />
                      </div>
                      <div>
                        <label>Destino</label>
                        <input
                          value={editRow.destination || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'destination')}
                        />
                      </div>
                    </div>
                  </TabPane>

                  {/* ── Tab: Material ── */}
                  <TabPane tabId="material">
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                      <div style={{gridColumn: '1 / -1'}}>
                        <label>Descripción de la mercadería</label>
                        <textarea
                          value={editRow.mercaderia_descripcion || ''}
                          className="form-control"
                          rows={3}
                          onChange={(e) => handleModalChange(e, 'mercaderia_descripcion')}
                        />
                      </div>
                      <div>
                        <label>Peso Bruto (kg)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={editRow.peso_bruto || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'peso_bruto')}
                        />
                      </div>
                      <div>
                        <label>Peso Neto (kg)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={editRow.peso_neto || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'peso_neto')}
                        />
                      </div>
                      <div>
                        <label>Medidas del embalaje</label>
                        <input
                          value={editRow.medidas_embalaje || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'medidas_embalaje')}
                          placeholder="Ej: 100x50x30 cm"
                        />
                      </div>
                      <div>
                        <label>Número de Serie</label>
                        <input
                          value={editRow.serial || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'serial')}
                        />
                      </div>
                      <div>
                        <label>Origen de la mercadería</label>
                        <input
                          value={editRow.origen_mercaderia || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'origen_mercaderia')}
                        />
                      </div>
                      <div>
                        <label>Marca y Modelo</label>
                        <input
                          value={editRow.marca_modelo || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'marca_modelo')}
                        />
                      </div>
                    </div>
                  </TabPane>

                  {/* ── Tab: Financiero ── */}
                  <TabPane tabId="financiero">
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                      <div>
                        <label>Valor a declarar (USD)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={editRow.valor_declarar || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'valor_declarar')}
                        />
                      </div>
                      <div>
                        <label>Valor de reparación (USD)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={editRow.valor_reparacion || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'valor_reparacion')}
                        />
                      </div>
                    </div>
                  </TabPane>

                  {/* ── Tab: Fechas ── */}
                  <TabPane tabId="fechas">
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                      <div>
                        <label>Fecha de presentación expediente</label>
                        <input
                          type="date"
                          value={
                            editRow.fecha_presentacion_expediente
                              ? new Date(editRow.fecha_presentacion_expediente).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'fecha_presentacion_expediente')}
                        />
                      </div>
                      <div>
                        <label>Fecha de aprobación expediente</label>
                        <input
                          type="date"
                          value={
                            editRow.aprobation_date
                              ? new Date(editRow.aprobation_date).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'aprobation_date')}
                        />
                      </div>
                      <div>
                        <label>Días habilitados por SICNEA</label>
                        <input
                          type="number"
                          value={editRow.sicnea_days || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'sicnea_days')}
                        />
                      </div>
                      <div>
                        <label>Fecha de embarque</label>
                        <input
                          type="date"
                          value={
                            editRow.fecha_embarque
                              ? new Date(editRow.fecha_embarque).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'fecha_embarque')}
                        />
                      </div>
                      <div>
                        <label>Fecha vencimiento temporal</label>
                        <input
                          type="date"
                          value={
                            editRow.fecha_vencimiento_temporal
                              ? new Date(editRow.fecha_vencimiento_temporal).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'fecha_vencimiento_temporal')}
                        />
                      </div>
                      <div>
                        <label>Fecha de vencimiento final</label>
                        <input
                          type="date"
                          value={
                            editRow.due_date
                              ? new Date(editRow.due_date).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'due_date')}
                        />
                      </div>
                    </div>
                  </TabPane>

                  {/* ── Tab: Prórrogas ── */}
                  <TabPane tabId="prorrogas">
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                      <div>
                        <label>Fecha presentación prórroga</label>
                        <input
                          type="date"
                          value={
                            editRow.fecha_presentacion_prorroga
                              ? new Date(editRow.fecha_presentacion_prorroga).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'fecha_presentacion_prorroga')}
                        />
                      </div>
                      <div>
                        <label>Fecha aprobación prórroga</label>
                        <input
                          type="date"
                          value={
                            editRow.fecha_aprobacion_prorroga
                              ? new Date(editRow.fecha_aprobacion_prorroga).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'fecha_aprobacion_prorroga')}
                        />
                      </div>
                      <div>
                        <label>Días habilitados por prórroga</label>
                        <input
                          type="number"
                          value={editRow.dias_habilitados_prorroga || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'dias_habilitados_prorroga')}
                        />
                      </div>
                      <div>
                        <label>Fecha de retorno</label>
                        <input
                          type="date"
                          value={
                            editRow.fecha_retorno
                              ? new Date(editRow.fecha_retorno).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'fecha_retorno')}
                        />
                      </div>
                    </div>
                  </TabPane>

                  {/* ── Tab: Customs ── */}
                  <TabPane tabId="customs">
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                      <div>
                        <label>Customs Declaration</label>
                        <input
                          value={editRow.custom_declaration || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'custom_declaration')}
                        />
                      </div>
                      <div>
                        <label>Channel</label>
                        <input
                          value={editRow.channel || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'channel')}
                        />
                      </div>
                      <div>
                        <label>Custom Doc. Date</label>
                        <input
                          type="date"
                          value={
                            editRow.custom_doc_date
                              ? new Date(editRow.custom_doc_date).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'custom_doc_date')}
                        />
                      </div>
                      <div>
                        <label>Release Date</label>
                        <input
                          type="date"
                          value={
                            editRow.release_date
                              ? new Date(editRow.release_date).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'release_date')}
                        />
                      </div>
                      <div>
                        <label>Local Delivery Note</label>
                        <input
                          value={editRow.local_delivery_note || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'local_delivery_note')}
                        />
                      </div>
                      <div>
                        <label>Delivery Date</label>
                        <input
                          type="date"
                          value={
                            editRow.delivery_date
                              ? new Date(editRow.delivery_date).toISOString().split('T')[0]
                              : ''
                          }
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'delivery_date')}
                        />
                      </div>
                    </div>
                  </TabPane>

                  {/* ── Tab: Estado ── */}
                  <TabPane tabId="estado">
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                      <div>
                        <label>Estado</label>
                        <select
                          value={editRow.status || 'Activo'}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'status')}
                        >
                          <option value="Activo">Activo</option>
                          <option value="Pronto a vencer">Pronto a vencer</option>
                          <option value="Vencido">Vencido</option>
                          <option value="Cumplida">Cumplida</option>
                        </select>
                      </div>
                      <div>
                        <label>Código ET</label>
                        <input
                          value={editRow.ET || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'ET')}
                        />
                      </div>
                      <div>
                        <label>Código IC</label>
                        <input
                          value={editRow.IC || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'IC')}
                        />
                      </div>
                      <div>
                        <label>PO de Servicio</label>
                        <input
                          value={editRow.po_servicio || ''}
                          className="form-control"
                          onChange={(e) => handleModalChange(e, 'po_servicio')}
                        />
                      </div>
                      <div style={{gridColumn: '1 / -1'}}>
                        <label>Comentarios</label>
                        <textarea
                          value={editRow.comentario || ''}
                          className="form-control"
                          rows={4}
                          onChange={(e) => handleModalChange(e, 'comentario')}
                          placeholder="Observaciones adicionales..."
                        />
                      </div>
                    </div>
                  </TabPane>

                  {/* ── Tab: Envases (con sub-tabs internos) ── */}
                  <TabPane tabId="envases">
                    {/* Sub-Nav interno naranja */}
                    <Nav tabs style={{padding: '0 0 0 4px', borderBottom: '1px solid #fed7aa', marginBottom: '16px'}}>
                      {[
                        {id: 'fechas_env', label: 'Fechas'},
                      ].map(st => (
                        <NavItem key={st.id}>
                          <NavLink
                            onClick={() => setEnvaseSubTab(st.id)}
                            style={{
                              cursor: 'pointer',
                              padding: '8px 14px',
                              fontSize: '13px',
                              fontWeight: envaseSubTab === st.id ? '600' : '400',
                              color: envaseSubTab === st.id ? '#f97316' : '#b45309',
                              borderBottom: envaseSubTab === st.id ? '2px solid #f97316' : '2px solid transparent',
                              backgroundColor: 'transparent',
                              border: 'none',
                            }}
                          >
                            {st.label}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>

                    {/* Sub-TabContent */}
                    <TabContent activeTab={envaseSubTab}>

                      {/* Sub-tab: Fechas */}
                      <TabPane tabId="fechas_env">
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px'}}>
                          <div>
                            <label>Despacho</label>
                            <input
                              value={editRow.despacho_envase || ''}
                              className="form-control"
                              onChange={(e) => handleModalChange(e, 'despacho_envase')}
                            />
                          </div>
                          <div>
                            <label>Fecha de presentación expediente</label>
                            <input
                              type="date"
                              value={editRow.fecha_presentacion_expediente_envase ? editRow.fecha_presentacion_expediente_envase.split('T')[0] : ''}
                              className="form-control"
                              onChange={(e) => handleModalChange(e, 'fecha_presentacion_expediente_envase')}
                            />
                          </div>
                          <div>
                            <label>Fecha de aprobación expediente</label>
                            <input
                              type="date"
                              value={editRow.fecha_aprobacion_expediente_envase ? editRow.fecha_aprobacion_expediente_envase.split('T')[0] : ''}
                              className="form-control"
                              onChange={(e) => handleModalChange(e, 'fecha_aprobacion_expediente_envase')}
                            />
                          </div>
                          <div>
                            <label>Días habilitados por SICNEA</label>
                            <input
                              type="number"
                              value={editRow.dias_habilitados_sicnea_envase || ''}
                              className="form-control"
                              onChange={(e) => handleModalChange(e, 'dias_habilitados_sicnea_envase')}
                            />
                          </div>
                          <div>
                            <label>Fecha de embarque</label>
                            <input
                              type="date"
                              value={editRow.fecha_embarque_envase ? editRow.fecha_embarque_envase.split('T')[0] : ''}
                              className="form-control"
                              onChange={(e) => handleModalChange(e, 'fecha_embarque_envase')}
                            />
                          </div>
                          <div>
                            <label>Fecha vencimiento temporal</label>
                            <input
                              type="date"
                              value={editRow.fecha_vencimiento_temporal_envase ? editRow.fecha_vencimiento_temporal_envase.split('T')[0] : ''}
                              className="form-control"
                              onChange={(e) => handleModalChange(e, 'fecha_vencimiento_temporal_envase')}
                            />
                          </div>
                          <div>
                            <label>Fecha de vencimiento final</label>
                            <input
                              type="date"
                              value={editRow.fecha_vencimiento_envase ? editRow.fecha_vencimiento_envase.split('T')[0] : ''}
                              className="form-control"
                              onChange={(e) => handleModalChange(e, 'fecha_vencimiento_envase')}
                            />
                          </div>
                        </div>
                      </TabPane>

                    </TabContent>
                  </TabPane>

                </TabContent>
              </>
            )}
          </ModalBody>
          <ModalFooter style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            {/* Navegación de tabs */}
            <div style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
              <Button
                color="outline-secondary"
                size="sm"
                disabled={currentNavIdx === 0}
                onClick={() => navigateToStep(NAV_STEPS[currentNavIdx - 1])}
              >
                ‹ Anterior
              </Button>
              <span style={{fontSize: '12px', color: '#6c757d', padding: '0 4px'}}>
                {currentNavIdx + 1} / {NAV_STEPS.length}
              </span>
              <Button
                color="outline-secondary"
                size="sm"
                disabled={currentNavIdx === NAV_STEPS.length - 1}
                onClick={() => navigateToStep(NAV_STEPS[currentNavIdx + 1])}
              >
                Siguiente ›
              </Button>
            </div>
            {/* Acciones */}
            <div style={{display: 'flex', gap: '6px'}}>
            {hasChanges && (
              <Button 
                color="primary" 
                onClick={handleModalSave}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: '8px' }}
                    ></span>
                    {isNew ? 'Agregando...' : 'Guardando...'}
                  </>
                ) : (
                  <>
                    <Icon name={isNew ? "plus" : "check"} style={{ marginRight: '5px' }} />
                    {isNew ? 'Agregar' : 'Guardar'}
                  </>
                )}
              </Button>
            )}{' '}
            <Button
              color="secondary"
              onClick={() => {
                setModalOpen(false);
                setIsNew(false);
                setHasChanges(false);
                setOriginalRow(null);
              }}
              disabled={isSaving}
            >
              Cerrar
            </Button>
            </div>
          </ModalFooter>
        </Modal>
        {/* Modal de historial */}
        <Modal
          isOpen={historyModalOpen}
          toggle={() => setHistoryModalOpen(false)}
          style={{maxWidth: '600px', width: '90%'}}
        >
          <ModalHeader toggle={() => setHistoryModalOpen(false)}>
            Historial de Cambios{' '}
            {historyData.length > 0 && historyData[0].referencia
              ? `- ${historyData[0].referencia}`
              : ''}
          </ModalHeader>
          <ModalBody>
            {historyData.length > 0 ? (
              <table
                className="table"
                style={{width: '100%', borderCollapse: 'collapse'}}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: '1px solid #ddd',
                        padding: '8px',
                        textAlign: 'center',
                      }}
                    >
                      Fecha
                    </th>
                    <th
                      style={{
                        border: '1px solid #ddd',
                        padding: '8px',
                        textAlign: 'center',
                      }}
                    >
                      Hora
                    </th>
                    <th
                      style={{
                        border: '1px solid #ddd',
                        padding: '8px',
                        textAlign: 'center',
                      }}
                    >
                      Acción
                    </th>
                    <th
                      style={{
                        border: '1px solid #ddd',
                        padding: '8px',
                        textAlign: 'center',
                      }}
                    >
                      Usuario
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {historyData.map((h, idx) => (
                    <tr key={h.id || idx}>
                      <td
                        style={{
                          border: '1px solid #ddd',
                          padding: '8px',
                          textAlign: 'center',
                        }}
                      >
                        {h.fecha}
                      </td>
                      <td
                        style={{
                          border: '1px solid #ddd',
                          padding: '8px',
                          textAlign: 'center',
                        }}
                      >
                        {h.hora}
                      </td>
                      <td
                        style={{
                          border: '1px solid #ddd',
                          padding: '8px',
                          textAlign: 'center',
                        }}
                      >
                        {h.accion}
                      </td>
                      <td
                        style={{
                          border: '1px solid #ddd',
                          padding: '8px',
                          textAlign: 'center',
                        }}
                      >
                        {h.usuario}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div>No hay historial disponible.</div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setHistoryModalOpen(false)}
            >
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal de Documentos */}
        <Modal
          isOpen={documentsModalOpen}
          toggle={() => setDocumentsModalOpen(false)}
          size="lg"
          style={{maxWidth: '1000px', width: '92%'}}
        >
          <ModalHeader
            toggle={() => setDocumentsModalOpen(false)}
          >
            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
              <span>Documentos - PO: <strong>{selectedPoNumber}</strong></span>
              {docCounts.total > 0 && (
                <span className="badge badge-light" style={{fontSize: '12px'}}>
                  {docCounts.total} archivo{docCounts.total !== 1 ? 's' : ''} total{docCounts.total !== 1 ? 'es' : ''}
                </span>
              )}
            </div>
          </ModalHeader>
          <ModalBody style={{padding: 0}}>
            {/* Navegación de Tabs estilo TDF */}
            <Nav tabs style={{
              padding: '0 16px',
              backgroundColor: '#f8f9fa',
              borderBottom: '2px solid #e5e7eb',
              marginBottom: '20px',
              display: 'flex',
              gap: '8px',
              flexWrap: 'nowrap',
              overflowX: 'auto'
            }}>
              {/* Solapa "Sin Asignar": aparece primero siempre y cuando haya docs sin asignar */}
              {docCounts.unassignedCount > 0 && (
                <NavItem>
                  <NavLink
                    className={docActiveTab === 'Sin Asignar' ? 'active' : ''}
                    onClick={() => setDocActiveTab('Sin Asignar')}
                    style={{
                      cursor: 'pointer',
                      padding: '12px 20px',
                      fontSize: '14px',
                      fontWeight: '600',
                      borderRadius: '8px 8px 0 0',
                      border: 'none',
                      color: docActiveTab === 'Sin Asignar' ? '#fff' : '#d56513',
                      background: docActiveTab === 'Sin Asignar' 
                        ? 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)' 
                        : 'transparent',
                      boxShadow: docActiveTab === 'Sin Asignar' ? '0 4px 12px rgba(247, 151, 30, 0.35)' : 'none',
                      transition: 'all 0.25s ease',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <Icon name="alert-circle" />
                    <span>Sin Asignar</span>
                    <span 
                      className="badge badge-pill" 
                      style={{
                        backgroundColor: docActiveTab === 'Sin Asignar' ? '#fff' : '#f7971e',
                        color: docActiveTab === 'Sin Asignar' ? '#d56513' : '#fff',
                        fontSize: '11px',
                        padding: '3px 8px'
                      }}
                    >
                      {docCounts.unassignedCount}
                    </span>
                  </NavLink>
                </NavItem>
              )}

              {/* Solapa "Import" */}
              <NavItem>
                <NavLink
                  className={docActiveTab === 'Import' ? 'active' : ''}
                  onClick={() => setDocActiveTab('Import')}
                  style={{
                    cursor: 'pointer',
                    padding: '12px 20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    borderRadius: '8px 8px 0 0',
                    border: 'none',
                    color: docActiveTab === 'Import' ? '#fff' : '#11998e',
                    background: docActiveTab === 'Import' 
                      ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)' 
                      : 'transparent',
                    boxShadow: docActiveTab === 'Import' ? '0 4px 12px rgba(17, 153, 142, 0.35)' : 'none',
                    transition: 'all 0.25s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <Icon name="download-cloud" />
                  <span>Import</span>
                  <span 
                    className="badge badge-pill" 
                    style={{
                      backgroundColor: docActiveTab === 'Import' ? '#fff' : '#11998e',
                      color: docActiveTab === 'Import' ? '#11998e' : '#fff',
                      fontSize: '11px',
                      padding: '3px 8px'
                    }}
                  >
                    {docCounts.importCount}
                  </span>
                </NavLink>
              </NavItem>

              {/* Solapa "Export" */}
              <NavItem>
                <NavLink
                  className={docActiveTab === 'Export' ? 'active' : ''}
                  onClick={() => setDocActiveTab('Export')}
                  style={{
                    cursor: 'pointer',
                    padding: '12px 20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    borderRadius: '8px 8px 0 0',
                    border: 'none',
                    color: docActiveTab === 'Export' ? '#fff' : '#667eea',
                    background: docActiveTab === 'Export' 
                      ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                      : 'transparent',
                    boxShadow: docActiveTab === 'Export' ? '0 4px 12px rgba(102, 126, 234, 0.35)' : 'none',
                    transition: 'all 0.25s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <Icon name="upload-cloud" />
                  <span>Export</span>
                  <span 
                    className="badge badge-pill" 
                    style={{
                      backgroundColor: docActiveTab === 'Export' ? '#fff' : '#667eea',
                      color: docActiveTab === 'Export' ? '#667eea' : '#fff',
                      fontSize: '11px',
                      padding: '3px 8px'
                    }}
                  >
                    {docCounts.exportCount}
                  </span>
                </NavLink>
              </NavItem>
            </Nav>

            <div style={{padding: '0 20px 20px 20px'}}>
              {/* Alerta informativa cuando se está en Sin Asignar */}
              {docActiveTab === 'Sin Asignar' && (
                <div className="alert alert-warning d-flex align-items-center mb-3" style={{borderRadius: '8px', fontSize: '13px'}}>
                  <Icon name="alert-circle" style={{fontSize: '20px', marginRight: '10px', color: '#d56513'}} />
                  <div>
                    Estos documentos aún no tienen clasificación. Selecciona <strong>Import</strong> o <strong>Export</strong> en la columna correspondiente para asignarlos a su solapa.
                  </div>
                </div>
              )}

              {/* Formulario de carga directa (solo activo en Import o Export) */}
              {docActiveTab !== 'Sin Asignar' && (
                <div style={{
                  marginBottom: '20px',
                  padding: '16px',
                  backgroundColor: docActiveTab === 'Import' ? '#f8fdfa' : '#f8f9fe',
                  borderRadius: '8px',
                  border: docActiveTab === 'Import' ? '1px solid #d1fae5' : '1px solid #e0e7ff'
                }}>
                  <h6 style={{
                    color: docActiveTab === 'Import' ? '#065f46' : '#3730a3',
                    marginBottom: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <Icon name="upload" /> Cargar nuevo documento de {docActiveTab}
                  </h6>
                  <MroDocuments 
                    key={`uploader-${docActiveTab}-${selectedPoNumber}`}
                    poNumber={selectedPoNumber}
                    documentType={docActiveTab}
                    idOrden={selectedTemporalId}
                    onUploadSuccess={() => {
                      setDocRefreshTrigger(prev => prev + 1);
                      refreshData();
                    }}
                  />
                </div>
              )}

              {/* Listado único de documentos filtrado reactivamente por docActiveTab */}
              <div style={{marginTop: '10px'}}>
                <h6 style={{color: '#18263F', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px'}}>
                  <Icon 
                    name="file-docs" 
                    className={docActiveTab === 'Import' ? 'text-success' : docActiveTab === 'Export' ? 'text-primary' : 'text-warning'} 
                  /> 
                  Documentos {docActiveTab === 'Sin Asignar' ? 'pendientes de clasificación' : `de ${docActiveTab}`}
                </h6>
                <MroDocumentsList 
                  poNumber={selectedPoNumber}
                  currentTab={docActiveTab}
                  onDeleteSuccess={refreshData}
                  onCountsChange={handleDocCountsChange}
                  refreshTrigger={docRefreshTrigger}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setDocumentsModalOpen(false)}
            >
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal de carga de Excel */}
        <TemporalesExcelUpload
          isOpen={excelUploadModalOpen}
          toggle={() => setExcelUploadModalOpen(false)}
          onUploadSuccess={refreshData}
        />

        {/* Modal de avisos */}
        <TemporalesMroAvisos
          isOpen={emailConfigModalOpen}
          toggle={() => setEmailConfigModalOpen(false)}
          onUploadSuccess={refreshData}
        />
      </Content>
    </React.Fragment>
  );
};

export default TemporalesMro;
